import React from 'react'
import { connect } from 'react-redux'
import { useHistory, NavLink } from 'react-router-dom'

import { Hidden, Drawer, Divider, Select, InputLabel } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import styled from '@emotion/styled'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import MenuIcon from '@material-ui/icons/Menu'
import Toolbar from '@material-ui/core/Toolbar'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import Collapse from '@material-ui/core/Collapse'
import Badge from '@material-ui/core/Badge'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import Popover from '@material-ui/core/Popover'
import UserAvatar from '../shared/UserAvatar'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SettingsIcon from '@material-ui/icons/Settings'
import addSVG from '../../assets/icons/add-icon-toolbar.svg'
import notificationsSVG from '../../assets/icons/notifications.svg'
import calendarSVG from '../../assets/icons/calendar.svg'
import { KeyboardArrowDown } from '@material-ui/icons'
import homepageSVG from '../../assets/icons/homepage.svg'
import { switchUser, LOGOUT as logout } from '../../store/auth/actions'
import {
  setSideBarStatus,
  setConfigExpanded,
  setSocioExpanded
} from '../../store/sidebar/actions'
import {
  roles,
  accessVersarProgram,
  accessClassrooms,
  accessForVersarAdmin,
  accessPublishContent,
  accessAnnouncements,
  accessReports,
  accessSwitchSchoolOrOccupation,
  accessUtils,
  accessMessages
} from '../../utils/constants'
import {
  clearNotifications,
  getNotifications,
  viewNotification
} from '../../store/notifications/actions'
import {
  getRoomsByIdRSPA,
  getChats,
  clearGroupRooms,
  clearPrivateRooms,
  clearMediationRooms
} from '../../store/chats/actions'

import { useHasAccess } from '../../utils/useHasAccess'
import { occupationsObject } from '../../utils/dicts'
import NotificationsMenu from './NotificationsMenu'
import { switchSchool } from '../../store/school/actions'
import MiniDrawer from './MiniDrawerMenu'
import StyledSVG from './../shared/StyledSVG'
import miniLogoDefault from '../../assets/minilogo-versar.svg'
import logoDefault from '../../assets/logo_versar.png'

const drawerWidth = 250

const MessageContainer = styled.div`
  position: absolute;
  border-radius: 16px;
  background-color: rgb(157, 210, 218);
  top: ${({ top }) => `${top}px`};
  color: black;
  padding: 8px;
  border-radius: 4px;
  z-index: 999;
`

const useStyles = makeStyles(theme => ({
  appBar: {
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'absolute',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth
    },
    '& .MuiToolbar-regular': {
      width: '100%',
      padding: '0 32px',
      [theme.breakpoints.down('sm')]: {
        padding: '0 10px'
      }
    }
  },
  logo: {
    width: '200px',
    padding: '10px 0',
    marginBottom: '30px'
  },
  user: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#555555',
    marginLeft: 'auto'
  },
  welcome: {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  userIcon: {
    fill: theme.palette.primary.main
  },
  menuBurguer: {
    color: theme.palette.primary.main
  },
  list: {
    paddingTop: '20px'
  },

  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  menuExitIcon: {
    width: 50
  },
  // necessary for content to be below app bar
  // toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  content: {
    overflow: 'hidden',
    gridArea: 'content',
    padding: '20px 30px 20px 30px',
    minHeight: 'calc(100vh - 65px)',
    display: 'flex',
    justifyContent: 'center'
  },
  appSearchAuth: {
    boxShadow: '-10px 10px 10px 0px #0000000D',
    overflowX: 'auto',
    display: 'flex',
    alignItems: 'center',
    width: '97%',
    [theme.breakpoints.up('sm')]: {
      minHeight: 50
    },
    padding: '0.5rem',
    background: 'white',
    borderRadius: '16px',
    justifyContent: 'space-between',
    [theme.breakpoints.down('820')]: {
      justifyContent: 'space-around'
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  msgIcon: {
    cursor: 'pointer',
    marginRight: '1rem',
    '& .MuiBadge-colorSecondary': {
      color: '#FFF'
    }
  },
  nullMessage: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  popover: {
    width: '15vw',
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end'
  },
  dashboard: {
    [theme.breakpoints.up('sm')]: {
      display: 'grid'
    },
    backgroundColor: '#F6F7F8',
    gridTemplateAreas: `
      "sidebar navbar"
      "sidebar content"
    `
  },
  selectedOccupation: {
    '& svg': {
      color: '#8B598E'
    }
  },
  selectedSchool: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    gap: 10,
    borderRadius: 16,
    backgroundColor: '#F5F5F5',
    '& svg': {
      color: '#8B598E'
    },
    '& #demo-simple-select': {
      width: 150
    },
    [theme.breakpoints.down('880')]: {
      height: 32,
      '& .MuiInputBase-root': {
        width: 100
      }
    },
    [theme.breakpoints.down('820')]: {
      '& .MuiInputBase-root': {
        width: 150
      }
    },
    [theme.breakpoints.down('400')]: {
      '& .MuiInputBase-root': {
        width: 90
      }
    }
  },
  toolbar: {
    // overflow: 'hidden',
    paddingTop: 10,
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gridArea: 'navbar'
  },
  homepage: {
    cursor: 'pointer',
    marginLeft: 20,
    [theme.breakpoints.down('sm')]: {
      marginRight: 20,
      marginLeft: 15
    },
    [theme.breakpoints.down('950')]: {
      '& span': {
        display: 'none'
      }
    },
    display: 'flex',
    alignItems: 'center',
    gap: 5,
    '& span': {
      color: '#868E96',
      fontSize: 14
    }
  },
  toolbarSecondSection: {
    display: 'flex',
    alignItems: 'center',
    gap: 40,
    [theme.breakpoints.down('820')]: {
      gap: 25
    }
  },
  verticalBar: {
    height: 23,
    width: 0,
    border: '1px solid #D2D5D8',
    [theme.breakpoints.down('820')]: {
      display: 'none'
    }
  },
  perfilComponent: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    width: 200,
    // minWidth: 200,
    minHeight: 35,
    borderRadius: 16,
    border: '0.5px solid #D2D5D8',
    [theme.breakpoints.down('1150')]: {
      width: 80,
      '& .userAttributes': {
        display: 'none !important'
      }
    },
    [theme.breakpoints.down('400')]: {
      width: 60,
      '& .userAttributes': {
        display: 'none !important'
      }
    }
  },
  arrowIcon: {
    color: '#8B598E',
    width: 20,
    height: 20,
    transform: 'rotate(0deg)', // Inicialmente sem rotação
    transition: 'transform 0.3s ease' // Adicione uma transição suave
  },
  rotated: {
    transform: 'rotate(180deg)' // Aplica a rotação de 180 graus quando 'rotated' é adicionado à classe
  },
  iconsOptions: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    [theme.breakpoints.down('820')]: {
      display: 'none'
    }
  }
}))

const mapStateToProps = ({
  auth,
  school,
  sidebar,
  room_menu,
  notifications
}) => {
  return {
    school: school,
    user: auth,
    sidebar: sidebar,
    fractalId: auth?.user?.data?.attributes?.fractal_id,
    room_menu_current_destination: room_menu.current_destination,
    notifications: notifications
  }
}

const mapDispatchToProps = dispatch => ({
  setSideBarStatus: data => dispatch(setSideBarStatus(data)),
  setConfigExpanded: data => dispatch(setConfigExpanded(data)),
  setSocioExpanded: data => dispatch(setSocioExpanded(data)),
  switchUser: data => dispatch(switchUser(data)),
  logout: data => dispatch(logout(data)),
  switchSchool: data => dispatch(switchSchool(data)),
  getNotifications: data => dispatch(getNotifications(data)),
  viewNotification: data => dispatch(viewNotification.request(data)),
  getRoomsByIdRSPA: data => dispatch(getRoomsByIdRSPA.request(data)),
  clearNotifications: data => dispatch(clearNotifications(data)),
  getChats: data => dispatch(getChats(data)),
  clearGroupRooms: data => dispatch(clearGroupRooms(data)),
  clearPrivateRooms: data => dispatch(clearPrivateRooms(data)),
  clearMediationRooms: data => dispatch(clearMediationRooms(data))
})

const MenuApp = ({
  window,
  children,
  logout,
  user,
  school,
  switchUser,
  switchSchool,
  setSideBarStatus,
  setConfigExpanded,
  setSocioExpanded,
  sidebar,
  fractalId,
  getNotifications,
  viewNotification,
  getRoomsByIdRSPA,
  notifications,
  clearNotifications,
  getChats,
  clearGroupRooms,
  clearPrivateRooms,
  clearMediationRooms,
  room_menu_current_destination
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const [mobileOpen, setMobileOpen] = React.useState(false)
  const [open, setOpen] = React.useState({
    socio: true,
    config: false
  })
  const [search] = React.useState({})
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [anchorMailEl, setAnchorMailEl] = React.useState(null)
  const [schoolsByUser, setSchoolsByUser] = React.useState(null)

  const [selectedOccupation, setSelectedOccupation] = React.useState(null)
  const [selectedSchool, setSelectedSchool] = React.useState(null)
  const [openProfile, setOpenProfile] = React.useState(false)
  const openMail = Boolean(anchorMailEl)
  const [showMessage, setShowMessage] = React.useState({
    homepage: false,
    addSocio: false,
    calendar: false
  })
  const [position, setPosition] = React.useState({ top: 0 })
  const handleClickUnmadePage = (e, from) => {
    const rect = e.target.getBoundingClientRect()
    setPosition({
      top: rect.bottom - 15
    })
    setShowMessage(prev => ({ ...prev, [from]: true }))
    setTimeout(() => setShowMessage(prev => ({ ...prev, [from]: false })), 500)
  }
  const hasAccess = useHasAccess()

  const projectsWithoutNewMessages = ['34', '49', '57', '54', '55', '56', '59']
  const projectsIdsWithoutSocio = ['59']
  const projectId = process.env.REACT_APP_PROJECT_ID.toString()
  const frontVersion = 'v1.10.0'
  const occupations = user.currentOccupation

  const isParent = occupations?.includes(roles.PARENT)
  const isVersarAdmin = occupations?.includes(roles.VERSAR_ADMIN)
  const schoolLogoUrl = school?.currentSchool?.school?.logo_url
  const schoolminiLogoUrl = school?.currentSchool?.school?.minilogo_url

  const schoolLogo = isVersarAdmin
    ? logoDefault
    : isParent ? schoolLogoUrl : schoolLogoUrl || logoDefault

  const miniLogo = isVersarAdmin
    ? miniLogoDefault
    : isParent ? schoolminiLogoUrl : schoolminiLogoUrl || miniLogoDefault

  function encodeQueryData (data) {
    const ret = []
    for (let d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
    return ret.join('&')
  }
  const ssoUrl = {
    local: 'http://localhost:8000/',
    staging: 'https://staging-fractalid.fractaltecnologia.com.br/',
    homolog: 'https://staging-fractalid.fractaltecnologia.com.br/',
    production: 'https://fractalid.fractaltecnologia.com.br/'
  }
  const { REACT_APP_PROJECT_ID, REACT_APP_SERVER_ENV = 'local' } = process.env

  const data = {
    app_id: REACT_APP_PROJECT_ID || 34
  }
  const urlString = encodeQueryData(data)
  const url = `${ssoUrl[REACT_APP_SERVER_ENV]}?${urlString}`

  const schoolOccupationItems = React.useMemo(
    () => {
      let key
      switch (user.currentOccupation[0]) {
        case roles.PARENT:
          key = 'schoolParents'
          break
        case roles.NURSE:
          key = 'schoolNurse'
          break
        case roles.PSYCHOLOGIST:
          key = 'schoolPsychologist'
          break
        case roles.TEACHER:
          key = 'schoolTeacher'
          break
        case roles.SCHOOL_ADMIN:
          key = 'schoolAdmin'
          break
        case roles.COORDINATOR:
          key = 'schoolCoordinator'
          break
        default:
          break
      }
      return key && school?.items?.[key]?.length ? school.items[key] : []
    },
    [user.currentOccupation]
  )

  const socketRef = React.useRef(null)
  const socketUrl = `${
    process.env.REACT_APP_PROJECT_API_HOST
  }/cable?fractal_id=${fractalId}`

  React.useEffect(
    () => {
      // get only messages notifications not seen by user
      getNotifications({
        page: 1
      })
      if (fractalId) {
        try {
          socketRef.current = new WebSocket(socketUrl)
          socketRef.current.onopen = () => {
            const subscribeMessage = JSON.stringify({
              command: 'subscribe',
              identifier: JSON.stringify({
                channel: 'NotificationChannel'
              })
            })
            socketRef.current.send(subscribeMessage)
          }
          socketRef.current.onerror = event => {
            console.error('Erro ao conectar ao websocket', event)
          }
          socketRef.current.onmessage = event => {
            const data = JSON.parse(event.data)
            if (
              data.type === 'ping' ||
              data.type === 'confirm_subscription' ||
              data.type === 'welcome' ||
              data.type === 'disconnect' ||
              data?.message?.user_id === fractalId
            ) {
              return
            }
            updateRoomsBySentNotification(data.message)
            getNotifications({ page: 1 })
          }

          socketRef.current.onclose = event => {
            socketRef.current?.close()
          }

          return () => socketRef.current?.close()
        } catch (error) {
          console.error('Erro ao conectar ao WebSocket', error)
        }
      }
    },
    [fractalId]
  )

  React.useEffect(
    () => {
      setSelectedOccupation(user.currentOccupation)
    },
    [user.currentOccupation]
  )
  React.useEffect(
    () => {
      setSelectedSchool(prev => school.currentSchool)
      schoolOccupationItems.length > 0 &&
        setSchoolsByUser(prev => {
          const newState = schoolOccupationItems
            ?.map(item => {
              return item?.school
            })
            ?.filter((item, index, self) => self.indexOf(item) === index)
          return newState
        })
    },
    [school.currentSchool]
  )

  const updateRoomsBySentNotification = async data => {
    if (room_menu_current_destination === 1 && data?.room_id) {
      const room = await getRoomsByIdRSPA(data.room_id).then(res => res)
      const isMediationMessage = data.parent_id && !data.content
      if (isMediationMessage) {
        clearMediationRooms()
      } else {
        switch (room.data.room_type) {
          case 'private':
            clearPrivateRooms()
            break
          case 'group':
            clearGroupRooms()
            break
        }
      }
      getChats({ page: 1 })
    }
  }

  const handleClick = req => {
    const option = req.target.id
    if (option === 'socio') {
      setOpen({ ...open, socio: !open.socio })
    } else if (option === 'config') {
      setOpen({ ...open, config: !open.config })
    }
  }

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const handleMenu = event => {
    setOpenProfile(!openProfile)
    setAnchorEl(event.currentTarget)
  }

  const handleClickMail = event => {
    setAnchorMailEl(event.currentTarget)
  }

  const handleCloseMail = () => {
    setAnchorMailEl(null)
  }

  const drawer = (
    <div className={classes.container}>
      <div className={classes.toolbar} />
      <List className={classes.list}>
        <ListItem component={NavLink} to={'/'}>
          <img src={schoolLogo} alt='Logo da escola' className={classes.logo} />
        </ListItem>
        <ListItem
          component={NavLink}
          id={'home'}
          className={classes.listItem}
          to={'/homepage'}
        >
          Homepage
        </ListItem>
        {hasAccess(accessVersarProgram) && (
          <div
            style={
              projectsIdsWithoutSocio.includes(projectId)
                ? { display: 'none' }
                : {}
            }
          >
            <ListItem
              id={'socio'}
              className={classes.listItem}
              onClick={handleClick}
            >
              Socioemocional
              {open.socio ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </ListItem>
            <Collapse in={open.socio} timeout='auto' unmountOnExit>
              <List component='div' disablePadding>
                <ListItem
                  component={NavLink}
                  to={'/socioemotional'}
                  className={`${classes.link} ${classes.nested}`}
                  activeClassName='Mui-selected'
                >
                  Conteúdos
                </ListItem>
                {hasAccess(accessPublishContent) && (
                  <ListItem
                    component={NavLink}
                    className={`${classes.nested} ${classes.link}`}
                    to={'/theme-schedule/grades'}
                    activeClassName='Mui-selected'
                  >
                    Publicar conteúdo
                  </ListItem>
                )}
                {hasAccess(accessForVersarAdmin) && (
                  <ListItem
                    component={NavLink}
                    className={`${classes.nested} ${classes.link}`}
                    to={'/theme-schedule/schools'}
                    activeClassName='Mui-selected'
                  >
                    Publicar conteúdo
                  </ListItem>
                )}
                {hasAccess(accessForVersarAdmin) && (
                  <ListItem
                    component={NavLink}
                    className={`${classes.nested} ${classes.link}`}
                    to={'/planning/grades'}
                    activeClassName='Mui-selected'
                  >
                    Templates
                  </ListItem>
                )}
              </List>
            </Collapse>
          </div>
        )}
        <>
          {user.currentOccupation[0] === 'parent' ? (
            <div />
          ) : (
            <>
              {hasAccess(accessAnnouncements) && (
                <ListItem
                  component={NavLink}
                  className={`${classes.listItem} ${classes.link}`}
                  to={'/announcements?name=list&event=communications'}
                  activeClassName='Mui-selected'
                >
                  Comunicados
                </ListItem>
              )}
              {hasAccess(accessMessages) && (
                <ListItem
                  component={NavLink}
                  className={`${classes.listItem} ${classes.link}`}
                  to={
                    projectsWithoutNewMessages.includes(projectId)
                      ? '/messages'
                      : '/rooms'
                  }
                  activeClassName='Mui-selected'
                >
                  Mensagens
                </ListItem>
              )}
              {hasAccess(accessForVersarAdmin) && (
                <ListItem
                  component={NavLink}
                  className={`${classes.listItem} ${classes.link}`}
                  to={
                    projectsWithoutNewMessages.includes(projectId)
                      ? '/messages/schools'
                      : '/rooms'
                  }
                  activeClassName='Mui-selected'
                >
                  Mensagens
                </ListItem>
              )}
            </>
          )}
        </>

        {hasAccess(accessReports) && (
          <ListItem
            component={NavLink}
            className={`${classes.listItem} ${classes.link}`}
            to={'/reports'}
            activeClassName='Mui-selected'
          >
            Diário de Turma
          </ListItem>
        )}
        {hasAccess(accessClassrooms) && (
          <ListItem
            component={NavLink}
            className={`${classes.listItem} ${classes.link}`}
            to={'/classrooms'}
            activeClassName='Mui-selected'
          >
            Turmas
          </ListItem>
        )}
        {user.currentOccupation[0] === 'parent' ? (
          <></>
        ) : (
          hasAccess(accessUtils) && (
            <ListItem
              component={NavLink}
              className={`${classes.listItem} ${classes.link}`}
              to={'/utils?name=list&util=menus'}
              activeClassName='Mui-selected'
            >
              Mural
            </ListItem>
          )
        )}
        <ListItem
          id={'config'}
          component={NavLink}
          className={`${classes.listItem}`}
          to={'/settings'}
          activeClassName='Mui-selected'
        >
          Configurações
        </ListItem>
      </List>
    </div>
  )

  const getSchoolByName = name => {
    const schoolObject = schoolOccupationItems?.find(
      schoolItem => schoolItem.school.name === name
    )
    return schoolObject
  }

  const handleChangeOccupation = event => {
    switchUser({
      occupation: event.target.value,
      id: user.user.data.id,
      history: history
    })
  }

  const handleChangeSchool = event => {
    const schl = getSchoolByName(event.target.value)
    switchSchool(schl)
    history.push('/')
  }

  const occupationsFiltered = user.user.data?.attributes?.occupations?.filter(
    item => {
      const allowOccupations = [
        'administrator',
        'school_administrator',
        'coordinator',
        'student',
        'teacher',
        'parent'
      ]
      return allowOccupations.includes(item)
    }
  )

  const container =
    window !== undefined ? () => window().document.body : undefined

  return (
    <div
      style={{ gridTemplateColumns: sidebar.open ? '1fr 10fr' : '0.5fr 12fr' }}
      className={classes.dashboard}
    >
      {/* sidebar (mobile) */}
      <Hidden smUp implementation='css'>
        <Drawer
          container={container}
          variant='temporary'
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper
          }}
          ModalProps={{
            keepMounted: true // Better open performance on mobile.
          }}
        >
          {drawer}
          <span>{frontVersion}</span>
        </Drawer>
      </Hidden>
      {/* sidebar (desktop) */}
      <Hidden xsDown implementation='css'>
        <MiniDrawer
          projectId={projectId}
          projectsIdsWithoutSocio={projectsIdsWithoutSocio}
          projectsWithoutNewMessages={projectsWithoutNewMessages}
          setConfigExpanded={setConfigExpanded}
          setSocioExpanded={setSocioExpanded}
          school={school}
          miniLogo={miniLogo}
          openSidebar={setSideBarStatus}
          sidebarControl={sidebar}
          logo={schoolLogo}
          logout={logout}
          frontVersion={frontVersion}
          occupations={occupations}
        />
      </Hidden>
      {/* header */}
      <Toolbar className={classes.toolbar}>
        <div className={classes.appSearchAuth}>
          <Hidden smUp implementation='css'>
            <IconButton
              color='inherit'
              aria-label='open drawer'
              edge='start'
              onClick={handleDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon className={classes.menuBurguer} />
            </IconButton>
          </Hidden>
          <Hidden xsDown implementation='css'>
            <div
              onClick={() => history.push('/homepage')}
              className={classes.homepage}
            >
              <StyledSVG src={homepageSVG} width={18} height={18} />
              <span>Homepage</span>
            </div>
            {showMessage.homepage && (
              <MessageContainer top={position.top}>
                Estamos trabalhando nisso!
              </MessageContainer>
            )}
          </Hidden>
          <div className={classes.toolbarSecondSection}>
            {hasAccess(accessSwitchSchoolOrOccupation) && (
              <>
                <div className={classes.selectedSchool}>
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: '50%',
                      marginLeft: 8,
                      backgroundColor: selectedSchool?.school?.primary_color
                    }}
                  />
                  <Select
                    labelId='demo-simple-select-label'
                    className='select'
                    disableUnderline
                    IconComponent={KeyboardArrowDown}
                    id='demo-simple-select'
                    value={selectedSchool?.school?.name || null}
                    onChange={event => {
                      schoolsByUser?.length > 1
                        ? handleChangeSchool(event)
                        : undefined
                    }}
                  >
                    {schoolsByUser?.length > 0 &&
                      schoolsByUser
                        .filter(
                          (school, index, self) =>
                            index ===
                            self.findIndex(schl => schl.id === school.id)
                        )
                        .map(schl => {
                          return (
                            <MenuItem key={schl.name} value={schl.name}>
                              {schl.name}
                            </MenuItem>
                          )
                        })}
                  </Select>
                </div>
                <div className={classes.verticalBar} />
                <div className={classes.iconsOptions}>
                  <StyledSVG
                    style={{ cursor: 'pointer' }}
                    onClick={event => handleClickUnmadePage(event, 'addSocio')}
                    src={addSVG}
                    width={18}
                    height={18}
                  />
                  {showMessage.addSocio && (
                    <MessageContainer top={position.top} left={position.left}>
                      Estamos trabalhando nisso!
                    </MessageContainer>
                  )}
                  <Badge
                    overlap='rectangular'
                    style={
                      projectsWithoutNewMessages.includes(projectId)
                        ? { display: 'none' }
                        : { cursor: 'pointer' }
                    }
                    badgeContent={notifications?.total_count}
                    onClick={handleClickMail}
                  >
                    <StyledSVG
                      src={notificationsSVG}
                      width={18}
                      height={18}
                      aria-describedby={openMail ? 'simple-popover' : undefined}
                    />
                  </Badge>
                  <Popover
                    id={openMail ? 'simple-popover' : undefined}
                    open={openMail}
                    anchorEl={anchorMailEl}
                    onClose={handleCloseMail}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                  >
                    <div className={classes.popover}>
                      <NotificationsMenu
                        handleCloseMail={handleCloseMail}
                        clearNotifications={clearNotifications}
                        viewNotification={viewNotification}
                        fractalId={fractalId}
                        getNotifications={getNotifications}
                        history={history}
                        notifications={notifications}
                      />
                    </div>
                  </Popover>
                  <StyledSVG
                    style={{ cursor: 'pointer' }}
                    onClick={event => handleClickUnmadePage(event, 'calendar')}
                    src={calendarSVG}
                    width={18}
                    height={18}
                  />
                  {showMessage.calendar && (
                    <MessageContainer top={position.top} left={position.left}>
                      Estamos trabalhando nisso!
                    </MessageContainer>
                  )}
                </div>
                <div className={classes.verticalBar} />
              </>
            )}
            <div className={classes.perfilComponent} onClick={handleMenu}>
              <UserAvatar
                avatarStyle={{
                  width: 27,
                  height: 27,
                  marginLeft: 4,
                  marginRight: '10px'
                }}
                withoutUserName
                userName={user.user.data?.attributes?.name}
                avatarUrl={user.user.data?.attributes?.avatar_url}
              />
              <div
                className='userAttributes'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start'
                }}
              >
                <span style={{ fontSize: 14, color: '#386093' }}>
                  {user.user.data?.attributes?.name.slice(0, 20)}
                </span>
                <span style={{ fontSize: 12, color: '#868E96' }}>
                  {occupationsObject[selectedOccupation]}
                </span>
              </div>

              <KeyboardArrowDown
                className={`${classes.arrowIcon} ${
                  openProfile ? classes.rotated : ''
                }`}
              />

              <Menu
                id='menu-appbar'
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={openProfile}
                onClose={() => setOpenProfile(false)}
                getContentAnchorEl={null}
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '10px'
                  }}
                >
                  {selectedOccupation && (
                    <span>{occupationsObject[selectedOccupation]}</span>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      lexDirection: 'row',
                      alignItems: 'center',
                      marginTop: '20px',
                      marginBottom: '15px'
                    }}
                  >
                    <UserAvatar
                      avatarStyle={{
                        marginLeft: 4,
                        marginRight: '10px'
                      }}
                      withoutUserName
                      userName={user.user.data?.attributes?.name}
                      avatarUrl={user.user.data?.attributes?.avatar_url}
                    />
                    <span>{user.user.data?.attributes?.name}</span>
                  </div>
                  {occupationsFiltered?.length > 1 && (
                    <>
                      <InputLabel id='demo-simple-select-label'>
                        Selecione uma ocupação
                      </InputLabel>
                      <Select
                        labelId='demo-simple-select-label'
                        id='demo-simple-select'
                        value={selectedOccupation}
                        onChange={event => {
                          const executeChange = () => {
                            localStorage.setItem('canDispatchAll', true)
                            handleChangeOccupation(event)
                          }
                          occupationsFiltered.length > 1
                            ? executeChange()
                            : undefined
                        }}
                      >
                        {occupationsFiltered.map(occupation => {
                          return (
                            <MenuItem key={occupation} value={occupation}>
                              {occupationsObject[occupation]}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    </>
                  )}
                </div>
                <Divider />
                <MenuItem>
                  <a
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      textDecoration: 'none',
                      color: 'inherit'
                    }}
                    href={url}
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    <SettingsIcon className={classes.menuExitIcon} />
                    Editar perfil
                  </a>
                </MenuItem>
                <MenuItem onClick={logout}>
                  <ExitToAppIcon className={classes.menuExitIcon} />
                  <span>Sair</span>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>
      </Toolbar>
      {/* body */}
      <main className={classes.content}>
        {React.cloneElement(children, { search: search })}
      </main>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuApp)
